import React, { FunctionComponent, useState, useEffect } from 'react';
import { useTheme } from '@mui/material/styles';
// import { useNavigate, useLocation } from 'react-router-dom';
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { useAtom } from 'jotai';
import { useTranslation } from 'react-i18next'
// import useMediaQuery from '@mui/material/useMediaQuery';

// import { check_subdomain } from '../../../lib/server_helper';
import { fetch_one, fetch_all, fetch_all_with_count } from "../../../lib/v31lib";
import { loginAtom } from '../../../lib/auth';
// import { currentPracticeAtom } from '../../../lib/practice';

import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';

// import {
//   Grid,
// } from '@mui/material';
import { GridColDef } from '@mui/x-data-grid-pro';

import {
  DataGrid,
  Dt,
  Fab,
  IconButton,
  Typography
} from '../../../components/v2/styled';
import { SnackDestroyed } from '../../../components/v2/snacks/Destroyed';
import { SnackSaved } from '../../../components/v2/snacks/Saved';

import { Medication } from '../../../models/Medication';
import { ClientMsboEdit } from '../../../components/v2/dialogs/ClientMsboEdit';
import { Chip } from '@mui/material';
import Visibility from '@mui/icons-material/Visibility';

const { DateTime } = require("luxon");

type Props = {}

export const ClientIntakeMsbo: FunctionComponent<Props> = ({}) => {
  const [login, setLogin] = useAtom(loginAtom);
  // const [currentPractice, setCurrentPractice] = useAtom(currentPracticeAtom);
  const theme = useTheme();
  // const navigate = useNavigate();
  const {t, i18n} = useTranslation(['translations']);
  // const queryClient = useQueryClient();
  // const { state } = useLocation();

  let count = 0;
  const [page, setPage] = useState<number>(0);
  const [order, setOrder] = useState<string>("IF(med_type='supplement' OR med_type='medicatie' OR ISNULL(med_type)=1, ISNULL(med_end), 0) DESC, IF(med_end>NOW(), 1, 0) DESC, med_start DESC, med_end DESC");
  const [savedOpen, setSavedOpen] = useState<boolean>(false);
  const [destroyedOpen, setDestroyedOpen] = useState<boolean>(false);

  const [med, setMed] = useState<Medication>();
  const [editOpen, setEditOpen] = useState<boolean>(false);

  const {
    data: medications,
    isLoading: objectsLoading,
    isError: objectsError,
    isSuccess: objectsSuccess,
    refetch: objectsRefetch,
  } = useQuery({
    queryKey: ["client", "medications", (login?.id), {page: page, order: order}],
    queryFn: () =>
      fetch_all_with_count<Medication>(
        `/${i18n.resolvedLanguage || 'nl'}/v3/objects/fetch_all`,
        {
          object: 'medication',
          fields: [
            'id', 'med_start', 'med_end', 'name', 'cause', 'med_type', 'doctor_note', 'med_interval', 'comment', 'user_id', 'practice_id', 'practice'
          ],
          sub_fields: {
            'practice': ['id', 'name']
          },
          per_page: 20,
          page: 0,
          order: order,
          skip_order_check: 1,
          filter: {
            search: '',
            advanced: {
              user_id: login?.id
            }
          }
        },
        login
      ),
    select: (d) => {
      count = d.count;
      return d.result;
    },
    enabled: !!login?.id,
  });








  const mutationDestroy = useMutation({
    mutationFn: (pars: {
      formData: any;
    }) => {
      return fetch_one<Medication>(
        `/${i18n.resolvedLanguage || 'nl'}/v3/objects/remove`,
        pars.formData,
        login
      );
    },
    onMutate: (pars: {
      formData: any;
    }) => {
      return true;
    },
    onError: (data, variables, context) => {
      return true;
    },
    onSuccess: (data, variables, context) => {
      objectsRefetch();
      setDestroyedOpen(true);
    },
  });
  const mutationSave = useMutation({
    mutationFn: (pars: {
      formData: any;
    }) => {
      return fetch_one<Medication>(
        `/${i18n.resolvedLanguage || 'nl'}/v3/objects/save`,
        pars.formData,
        login
      );
    },
    onMutate: (pars: {
      formData: any;
    }) => {
      return true;
    },
    onError: (data, variables, context) => {
      return true;
    },
    onSuccess: (data, variables, context) => {
      setEditOpen(false);
      objectsRefetch();
      setSavedOpen(true);
    },
  });








  const columns: GridColDef[] = [
    // { field: 'id', headerName: 'ID', width: 80 },
    { field: 'name', headerName: t("coach.models.medications.name"), width: 240 },
    { field: 'med_type', headerName: t("client.models.medications.med_type"), width: 160, renderCell: params => <>
      {params.row.med_type === 'medicatie' && <Chip sx={{fontSize: '0.9rem', backgroundColor: '#8FB3E0'}}label={t("client.models.medications.med_types.medication")} />}
      {params.row.med_type === 'supplement' && <Chip sx={{fontSize: '0.9rem', backgroundColor: '#8FB3E0'}} label={t("client.models.medications.med_types.supplement")} />}
      {params.row.med_type === 'treatment' && <Chip sx={{fontSize: '0.9rem', backgroundColor: '#F7C48A'}} label={t("client.models.medications.med_types.treatment")} />}
      {params.row.med_type === 'research' && <Chip sx={{fontSize: '0.9rem', backgroundColor: '#B3A6D6'}} label={t("client.models.medications.med_types.research")} />}
      {params.row.med_type === 'operation' && <Chip sx={{fontSize: '0.9rem', backgroundColor: '#F7C48A'}} label={t("client.models.medications.med_types.operation")} />}
      {params.row.med_type === 'complaint' && <Chip sx={{fontSize: '0.9rem', backgroundColor: '#F2A08C'}} label={t("client.models.medications.med_types.complaint")} />}
      {params.row.med_type === 'important_event' && <Chip sx={{fontSize: '0.9rem', backgroundColor: '#F2A08C'}} label={t("client.models.medications.med_types.important_event")} />}
      {params.row.med_type === 'diet' && <Chip sx={{fontSize: '0.9rem', backgroundColor: '#97BE6B'}} label={t("client.models.medications.med_types.diet")} />}
    </> },
    { field: 'med_start', headerName: t("coach.models.medications.med_start"), width: 120, renderCell: params => <>
      <Dt d={params.row.med_start} f="dd/LL/y" />
    </> },
    { field: 'med_end', headerName: t("coach.models.medications.med_end"), width: 120, renderCell: params => <>
      {!!params.row.med_end && <Dt d={params.row.med_end} f="dd/LL/y" />}
    </> },
    { field: 'practice_name', headerName: t("coach.models.medications.practice_name"), width: 200 },
  ];

  return <>
    <DataGrid
      action_count={2}
      hideCount
      cellPAlign
      actions={(params) => {
        return (<>
          <IconButton title="Edit" color="default" onClick={() => {
            setMed({
              ...params.row,
              med_start: DateTime.fromISO(params.row.med_start).toFormat("dd/LL/y"),
              med_end: !!params.row.med_end ? DateTime.fromISO(params.row.med_end).toFormat("dd/LL/y") : undefined
            });
            setEditOpen(true);
          }}>
            {!params.row.practice_id && <EditIcon />}
            {!!params.row.practice_id && <Visibility />}
          </IconButton>
          {!params.row.practice_id && <IconButton title="Remove" destroyBtn color="default" onClick={() => {
            mutationDestroy.mutate({
              formData: {
                object: 'medication',
                id: params.row.id,
                ob: {
                  id: params.row.id,
                }
              }
            });
          }}>
            <DeleteIcon />
          </IconButton>}
        </>);
      }}
      objectCount={count}
      getRowClassName={(params) => `datagrid-row-enabled-${params.row.enabled}`}
      objects={(medications || []).map(u => ({
        ...u,
        // name: [u.last_name, u.first_name].join(", "),
        // enabled: !!u.enabled && !!u.consent_status?.enabled,
        practice_name: (u.practice?.name || '')
      }))}
      columns={columns}
      loader={objectsLoading}
      onSortModelChange={(a, b) => {
        let a_0_field:string = a[0].field;
        if (a_0_field === 'name') a_0_field = `last_name ${a[0].sort}, first_name`;
        setOrder([a_0_field, a[0].sort].join(' '));
      }}
      page={page}
      setPage={(p) => {setPage(p);}}
    />

    <Fab
      onClick={() => {
        setMed({name: '', med_start: DateTime.now().toFormat("dd/LL/y")});
        setEditOpen(true);
      }}
    />

    <SnackDestroyed open={destroyedOpen} setOpen={setDestroyedOpen} />
    <SnackSaved open={savedOpen} setOpen={setSavedOpen} />

    <ClientMsboEdit
      onClick={() => {
        if (!!med) {
          let {practice, ...newMed} = med;
          mutationSave.mutate({
            formData: {
              object: 'medication',
              handler_id: login?.id,
              id: newMed?.id,
              ob: {
                ...newMed,
                user_id: login?.id
              }
            }
          });
        }
      }}
      open={editOpen}
      setOpen={setEditOpen}
      medication={med || {name: ''}}
      setMedication={setMed}
    />
  </>;
}

